import { render } from "./IncomeCard.vue?vue&type=template&id=ca560e3e&scoped=true"
import script from "./IncomeCard.vue?vue&type=script&lang=js"
export * from "./IncomeCard.vue?vue&type=script&lang=js"

import "./IncomeCard.vue?vue&type=style&index=0&id=ca560e3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca560e3e"]])

export default __exports__